import React from 'react';
import { v4 as uuid } from 'uuid';
import { Helmet } from 'react-helmet';

import { makeStyles } from '@material-ui/core/styles';

import Header from './Header';
import Features from '../CB11Patch/Features';
import Destructured from './Destructured';
import TechSpecs from '../CB11Patch/TechSpecs';
import I18n from '../I18n';

const featuresInfo = [
  {
    flexDirection: 'row-reverse',
    text: [`${I18n('CB11Handheld.featuresInfo_1')}`],
    imgSrc: '/CB11/CB11handheldFrontAndBack.png',
    imgAlt: 'CB11 handheld'
  },
  {
    flexDirection: 'row',
    text: [
	    `${I18n('CB11Handheld.featuresInfo_2_1')}`,
	    `${I18n('CB11Handheld.featuresInfo_2_2')}`
    ],
    imgSrc: '/CB11/CB11held.svg',
    imgAlt: 'CB11 handheld held in hands'
  },
  {
    flexDirection: 'row-reverse',
    text: [`${I18n('CB11Handheld.featuresInfo_3')}`],
    imgSrc: '/devices/pixel_ECG_port.png',
    imgAlt: 'pixel phone showing ECG'
  }
];

const specInfo = [
  {
    title: `${I18n('CB11Handheld.specInfo_title_1')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_1')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_2')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_2')}`
  },
  /*
  {
    title: `${I18n('CB11Handheld.specInfo_title_3')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_3')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_4')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_4')}`
  },
  */
  {
    title: `${I18n('CB11Handheld.specInfo_title_5')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_5')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_6')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_6')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_7')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_7')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_8')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_8')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_9')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_9')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_10')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_10')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_11')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_11')}`
  },
  {
    title: `${I18n('CB11Handheld.specInfo_title_12')}`,
    detail: `${I18n('CB11Handheld.specInfo_detail_12')}`
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}));

const CB11Handheld = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Helmet>
        <title>{I18n('CB11var.title')} {I18n('CB11var.description')} </title>
        <meta
          name='description'
          content='Handheld ECG sensor. Medical grade short-term cardiac monitoring. Takes a 30-180 second ECG recording.'
        />
      </Helmet>
      <Header />
      {featuresInfo.map((info) => (
        <Features key={uuid()} {...info} />
      ))}
      <Destructured />
      <TechSpecs title={I18n('CB11Handheld.technical_specs')} specInfo={specInfo} />
    </div>
  );
};

export default CB11Handheld;
